import AndroidStore from './android-store.svg?sprite'
import Apple from './apple.svg?sprite'
import Bluesky from './bluesky.svg?sprite'
import Bridge from './bridge.svg?sprite'
import CaretRight from './caret-right.svg?sprite'
import Check from './check.svg?sprite'
import ChevronLeft from './chevron-left.svg?sprite'
import ChevronRight from './chevron-right.svg?sprite'
import Circles4 from './circles4.svg?sprite'
import Close from './close.svg?sprite'
import Collapse from './collapse.svg?sprite'
import Copy from './copy.svg?sprite'
import Desktop from './desktop.svg?sprite'
import Discord from './discord.svg?sprite'
import Dislike from './dislike.svg?sprite'
import Download from './download.svg?sprite'
import Eye from './eye.svg?sprite'
import Facebook from './facebook.svg?sprite'
import Fennek from './fennek.svg?sprite'
import Flag from './flag.svg?sprite'
import Fullscreen from './fullscreen.svg?sprite'
import Gift from './gift.svg?sprite'
import Github from './github.svg?sprite'
import Google from './google.svg?sprite'
import Hand from './hand.svg?sprite'
import HappyCloud from './happy-cloud.svg?sprite'
import Heart from './heart.svg?sprite'
import Info from './info.svg?sprite'
import Lightning from './lightning.svg?sprite'
import Like from './like.svg?sprite'
import LinkedIn from './linked-in.svg?sprite'
import Loader from './loader.svg?sprite'
import Logout from './logout.svg?sprite'
import Menu from './menu.svg?sprite'
import Microsoft from './microsoft.svg?sprite'
import Pause from './pause.svg?sprite'
import Play from './play.svg?sprite'
import PlaygamaApp from './playgama-app.svg?sprite'
import Plus from './plus.svg?sprite'
import Poop from './poop.svg?sprite'
import QrCode from './qr-code.svg?sprite'
import Reddit from './reddit.svg?sprite'
import SadCloud from './sad-cloud.svg?sprite'
import ScrollToTop from './scroll-to-top.svg?sprite'
import Search from './search.svg?sprite'
import Send from './send.svg?sprite'
import Smile from './smile.svg?sprite'
import Star from './star.svg?sprite'
import Steam from './steam.svg?sprite'
import Tag from './tag.svg?sprite'
import Telegram from './telegram.svg?sprite'
import Twitter from './twitter.svg?sprite'
import TwoFingers from './two-fingers.svg?sprite'
import Wallet from './wallet.svg?sprite'

export const commonIcons = {
    'android-store': AndroidStore,
    apple: Apple,
    bluesky: Bluesky,
    bridge: Bridge,
    'caret-right': CaretRight,
    check: Check,
    'chevron-left': ChevronLeft,
    'chevron-right': ChevronRight,
    close: Close,
    collapse: Collapse,
    copy: Copy,
    desktop: Desktop,
    discord: Discord,
    dislike: Dislike,
    download: Download,
    eye: Eye,
    facebook: Facebook,
    fennek: Fennek,
    flag: Flag,
    fullscreen: Fullscreen,
    gift: Gift,
    google: Google,
    github: Github,
    circles4: Circles4,
    hand: Hand,
    'happy-cloud': HappyCloud,
    heart: Heart,
    info: Info,
    like: Like,
    lightning: Lightning,
    'linked-in': LinkedIn,
    loader: Loader,
    logout: Logout,
    menu: Menu,
    microsoft: Microsoft,
    pause: Pause,
    play: Play,
    'playgama-app': PlaygamaApp,
    plus: Plus,
    poop: Poop,
    'qr-code': QrCode,
    reddit: Reddit,
    'sad-cloud': SadCloud,
    'scroll-to-top': ScrollToTop,
    search: Search,
    send: Send,
    smile: Smile,
    star: Star,
    steam: Steam,
    tag: Tag,
    telegram: Telegram,
    twitter: Twitter,
    'two-fingers': TwoFingers,
    wallet: Wallet,
}
